import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';

import Header from '../Header';
import Input from '../Input';
import Select from '../Select';
import Checkbox from '../Checkbox';
import Radio from '../Radio';
import RadioGroup from '../RadioGroup';
import Graph from '../Graph';
import FormTable from '../FormTable';
import PageSection from '../PageSection';
import PageTitle from '../PageTitle';
import Table from '../Table';
import ConfigurationForm from '../ConfigurationForm';
import ThankYou from '../ThankYou';
import ButtonGroup from '../ButtonGroup';

import SiteLogo from '../../assets/images/global/seakeeper-logo.png';

class StyleTile extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.radios = [
			{
				label: 'yes',
				htmlID: 'yes',
				htmlName: 'question',
				defaultValue: 'yes'
			},
			{
				label: 'no',
				htmlID: 'no',
				htmlName: 'question',
				defaultValue: 'no'
			}
		];

		this.actions = <button className="pp-button">Button</button>;

		this.tableData = {
			heading: ['one', 'two', 'three', 'four'],
			body: [
				['start','b','c','d'],
				['a','b','c','d'],
				['a','b','c','d'],
				['a','b','c','d'],
				['a','b','c','d'],
				['a','b','c','d'],
				['a','b','c','end']
			]
		}

		this.thankYouTitle = 'Thank you for submitting a Seakeeper Sizing Form!';
		this.thankYouMessage = "We'll notify you when your report is published. You can check its status on your Dashboard.";

		this.buttonGroupOptions = ['Metric','English']
		this.buttonGroupSelected = 0;
		this.buttonGroupValue = 'Metric';
	}

	render() {
		return (
			<div className="style-tile-page">

				<h1 className="style-tile-spacer">Header</h1>
				<Header />

				<h1 className="style-tile-spacer">Input</h1>
				<Input htmlID="text-input" label="This is an input field" placeholderText="Placeholder text" />

				<h1 className="style-tile-spacer">Select</h1>
				<Select htmlID="select-input" label="This is a select field" />

				<h1 className="style-tile-spacer">Checkbox</h1>
				<Checkbox htmlID="checkbox-input" label="This is a checkbox" />

				<h1 className="style-tile-spacer">Radio</h1>
				<Radio htmlID="radio-input" label="This is a radio button" />

				<h1 className="style-tile-spacer">Buttons</h1>
				<button className="pp-button">Button</button>
				<button className="pp-text-button">This is a button</button>

				<h1 className="style-tile-spacer">Graph</h1>
				<Graph />

				<h1 className="style-tile-spacer">Page Title</h1>
				<PageTitle pageTitle="Dashboard" pageActions={this.actions} />

				<h1 className="style-tile-spacer">Form Table inside Page Section</h1>
				<PageSection sectionTitle="Sizing Form" sectionActions={this.actions}>
					<FormTable />
				</PageSection>

				<h1 className="style-tile-spacer">Radio Group</h1>
				<RadioGroup label="This is a radio group label" radioOptions={this.radios} />

				<h1 className="style-tile-spacer">Table</h1>
				<PageSection sectionTitle="Table">
					<Table tableHeading={this.tableData.heading} tableBody={this.tableData.body} />
				</PageSection>

				<h1 className="style-tile-spacer">Configurations</h1>
				<PageSection sectionTitle="Configurations">
					<ConfigurationForm />
				</PageSection>

				<h1 className="style-tile-spacer">Thank You</h1>
				<ThankYou
					icon={SiteLogo}
					title={this.thankYouTitle}
					message={this.thankYouMessage}
				/>

				<h1 className="style-tile-spacer">Button Group</h1>
				<ButtonGroup
					options={this.buttonGroupOptions}
					selected={this.buttonGroupSelected}
					value={this.buttonGroupValue}
				/>
			</div>
		);
	}
}

export default StyleTile;



// WEBPACK FOOTER //
// ./src/components/pages/StyleTile.js